const TicketSource = {
  Aplikacja: 'Aplikacja' as 'Aplikacja',
  BazaWiedzy: 'BazaWiedzy' as 'BazaWiedzy',
  Czat: 'Czat' as 'Czat',
  BiuroRachunkowe: 'BiuroRachunkowe' as 'BiuroRachunkowe',
  ZakladanieSpolek: 'ZakladanieSpolek' as 'ZakladanieSpolek',
  Kontakt: 'Kontakt' as 'Kontakt',
};
type TicketSource = (typeof TicketSource)[keyof typeof TicketSource]

export {TicketSource}


// WEBPACK FOOTER //
// ./src/models/freshworks.ts